module.exports = __webpack_public_path__ + "static/media/AMC-details-background.9418f0f6.jpg";